import React, { useState, useEffect } from 'react';
import './Style/AllUsers.css'; // Create this CSS file
import TopNavbar from '../home/TopNavbar';
import Loading from '../home/Loading';
import UseUsersDataBeforeLogin from './UseUsersDataBeforeLogin';

const AllUsersBeforeLogin = () => {
    const { allusers, loading } = UseUsersDataBeforeLogin();

    // If loading, show loading component
    if (loading) {
        return <Loading />;
    }

    return (
        <div className="all-user-data-container">
            <div className="user-data-content-wrapper">
                <TopNavbar name="All Users Data" />

                <div className="user-data-card">
                    <h2 className="user-data-title">All Users Information</h2>
                    
                    <div className="table-responsive">
                        <table className="user-data-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Class</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allusers && allusers.length > 0 ? (
                                    allusers.map((user, index) => (
                                        <tr key={user.id || index}>
                                            <td>{index + 1}</td>
                                            <td>{user.name || 'N/A'}</td>
                                            <td>{user.class || 'N/A'}</td>
                                            <td>{user.phone || 'N/A'}</td>
                                            <td>{user.email || 'N/A'}</td>
                                            <td>{user.date || 'N/A'}</td>
                                          
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="no-data-message">
                                            No users found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="user-data-stats">
                        <p>Total Users: <strong>{allusers ? allusers.length : 0}</strong></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllUsersBeforeLogin;